import axios from 'axios';
import {API_ROOT} from '../app/utils';
import {findCollaborators, flash, getSharingDetailsPopup} from './sharingDetailsActions';
import {getSelectedContactsGroup} from './contactsGroupItemActions';
import {webfulTrack} from '../app/utils/webful';

let timeOutFunc = null;

export function findDirectoryGroups (redirect, history) {
	return function (dispatch, getState) {
		axios.get(API_ROOT + '/api/v2/directory/groups', {withCredentials: true}).then( response => {

			if(response.data.state === 'SUCCEED'){

				if(timeOutFunc){
					clearTimeout(timeOutFunc);
				}

				dispatch({
					type: "FIND_DIRECTORY_GROUPS",
					payload: response.data
				});

				/*
				* Redirect to the desactivated or activated Directory label
				* */

				if(redirect){
					if(response.data.directoryContactGroupsV4[0].activeDirectory){
						history.push('/label/' + response.data.directoryContactGroupsV4[0].rootOu.id);
						if(getState().directoryGroupReducer.isActivatingDirectorySync){
							dispatch(isActivatingDirectorySync(false));
						}
					} else {
						history.push('/label/' + response.data.directoryContactGroupsV4[0].customerId);
					}
				}

				/*
				* If selected Directory Group exists, it's updated on activation
				* */

				/*response.data.directoryContactGroupsV4.forEach( (item, index) => {

					if(getState().contactsGroupItemReducer.getSelectedContactsGroup){
						if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === 'directory'){
							if(parseInt(getState().contactsGroupItemReducer.getSelectedContactsGroup.index, 10) === index){

								let selectedDirectoryGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;

								dispatch(getSelectedContactsGroup({
									...selectedDirectoryGroup,
									'id' : item.id,
									'ownerId' : item.ownerId,
									'activeDirectory' : item.activeDirectory.toString()
								}));

								if(!noContactAPICall){
									dispatch(resetContacts());
									dispatch(findContacts(item.id, store.getState().contactReducer.contactsPageSize));
								}

							}
						}
					}


				});*/

			} else if (response.data.state === 'RUNNING') {

				if(getState().directoryGroupReducer.waitingDirectoryGroupsLevel < 1){
					timeOutFunc = setTimeout(() => {
						dispatch(findDirectoryGroups());
						clearTimeout(timeOutFunc);
						dispatch(waitingDirectoryGroupsLevel(getState().directoryGroupReducer.waitingDirectoryGroupsLevel + 1));
					}, 2000);
				} else if(getState().directoryGroupReducer.waitingDirectoryGroupsLevel < 2){
					timeOutFunc = setTimeout(() => {
						dispatch(findDirectoryGroups());
						clearTimeout(timeOutFunc);
						dispatch(waitingDirectoryGroupsLevel(getState().directoryGroupReducer.waitingDirectoryGroupsLevel + 1));
					}, 3000);
				} else {
					dispatch(waitingDirectoryGroupsLevel(getState().directoryGroupReducer.waitingDirectoryGroupsLevel + 1));
				}

				dispatch({
					type: "FIND_DIRECTORY_GROUPS",
					payload: response.data
				});

			} else if (response.data.state === 'FAIL') {

				if(timeOutFunc){
					clearTimeout(timeOutFunc);
				}

				dispatch({
					type: "FIND_DIRECTORY_GROUPS",
					payload: response.data
				});
				dispatch(getSharingDetailsPopup([true, 'labels_loading_error', response.data.message]));

			} else {

				dispatch({
					type: "FIND_DIRECTORY_GROUPS",
					payload: { state: 'FAIL', directoryContactGroupsV4: [] }
				});
				dispatch(getSharingDetailsPopup([true, 'labels_loading_error', 'Unknown error']));

			}

		}).catch(e => {
			console.log(e);
			dispatch({
				type: "FIND_DIRECTORY_GROUPS",
				payload: { state: 'FAIL', directoryContactGroupsV4: [] }
			});
		});
	}
}

export function activateDirectorySync(directorySyncType, history) {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/directory/group/activate?directorySyncType=' + directorySyncType + '&source=WEBAPP', '', {withCredentials: true}).then( response => {

			dispatch({
				type: "ACTIVATE_DIRECTORY",
				payload: response.data
			});

			dispatch(flash({type: 'success', message: response.data}));

			// Webful In-App Analytics
			webfulTrack('directory_sync_activated', { sync_type: directorySyncType });

			dispatch(findDirectoryGroups(true, history));

		}).catch(e => {
			dispatch(flash({type: 'danger', message: e.response.data}));
		});
	}
}

export function isActivatingDirectorySync (boolean) {
	return {
		type: "IS_ACTIVATING_DIRECTORY_SYNC",
		payload: boolean
	}
}

export function switchDirectorySyncType (directorySyncType, ownerId, groupId) {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/directory/syncType?directorySyncType=' + directorySyncType, '&directoryOwnerId=' + ownerId + '&directoryGroupId=' + groupId, {withCredentials: true}).then( response => {

			dispatch({
				type: "SWITCH_DIRECTORY_SYNC_TYPE",
				payload: response.data
			});

			dispatch(flash({type: 'success', message: response.data}));
			dispatch(findDirectoryGroups());

		}).catch(e => {
			dispatch(flash({type: 'danger', message: e.response.data}));
		});
	}
}

export function deactivateDirectorySync(history) {
	return function (dispatch, getState) {
		axios.delete(API_ROOT + '/api/v2/directory/group/deactivate?customerId=' + getState().contactsGroupItemReducer.getSelectedContactsGroup.customerId, {withCredentials: true}).then( response => {
			dispatch({
				type: "DEACTIVATE_DIRECTORY",
				payload: response.data
			});
			dispatch(flash({type: 'success', message: response.data}));
			dispatch(findDirectoryGroups(true, history));
		}).catch(e => {
			dispatch(flash({type: 'danger', message: e.response.data}));
		});
	}
}

export function isDirectorySyncRunning (boolean) {
	return {
		type: "IS_DIRECTORY_SYNC_RUNNING",
		payload: boolean
	};
}

export function isCollapsed (array) {
	return {
		type: "IS_COLLAPSED",
		payload: array
	};
}

export function isHidden (array) {
	return {
		type: "IS_HIDDEN",
		payload: array
	};
}

export function directoryLabelsToCollapse (object) {
	return function (dispatch, getState) {

		getState().directoryGroupReducer.findDirectoryGroups.directoryContactGroupsV4.forEach( item => {
			if(object.labelType === "directory"){

				if(item.customerId !== object.customerId){
					return;
				}

				dispatch(isCollapsed([
					...getState().directoryGroupReducer.isCollapsed,
					object.labelId
				]));

				item.rootOu.childOu.forEach(childOuItem => {

					if(getState().directoryGroupReducer.isHidden.includes(childOuItem.id) === false) {
						dispatch(isHidden([
							...getState().directoryGroupReducer.isHidden,
							childOuItem.id
						]));
					}

					childOuItem.childOu.forEach(childOuItemLv2 => {
						if(getState().directoryGroupReducer.isHidden.includes(childOuItemLv2.id) === false) {
							dispatch(isHidden([
								...getState().directoryGroupReducer.isHidden,
								childOuItemLv2.id
							]))
						}
					})
				})
			} else {
				item.rootOu.childOu.forEach(childOuItem => {
					if(childOuItem.id === object.labelId){

						if(getState().directoryGroupReducer.isCollapsed.includes(object.labelId) === false) {
							dispatch(isCollapsed([
								...getState().directoryGroupReducer.isCollapsed,
								object.labelId
							]));
						}

						childOuItem.childOu.forEach(childOuItemLv2 => {
							if(getState().directoryGroupReducer.isHidden.includes(childOuItemLv2.id) === false) {
								dispatch(isHidden([
									...getState().directoryGroupReducer.isHidden,
									childOuItemLv2.id
								]))
							}
						})
					}
				})
			}

		})
	};
}

export function directoryLabelsToExpend (object) {
	return function (dispatch, getState) {
		dispatch(isCollapsed([...getState().directoryGroupReducer.isCollapsed.filter((collapsedItem) => collapsedItem !== object.labelId)]));

		getState().directoryGroupReducer.findDirectoryGroups.directoryContactGroupsV4.forEach( item => {
			if(object.labelType === "directory"){

				if(item.customerId !== object.customerId){
					return;
				}

				item.rootOu.childOu.forEach(childOuItem => {

					dispatch(isHidden([...getState().directoryGroupReducer.isHidden.filter((collapsedItem) => collapsedItem !== childOuItem.id)]));
					dispatch(isCollapsed([...getState().directoryGroupReducer.isCollapsed.filter((collapsedItem) => collapsedItem !== childOuItem.id)]));

					childOuItem.childOu.forEach(childOuItemLv2 => {
						dispatch(isHidden([...getState().directoryGroupReducer.isHidden.filter((collapsedItem) => collapsedItem !== childOuItemLv2.id)]));
					});
				})
			} else {
				item.rootOu.childOu.forEach(childOuItem => {
					if(childOuItem.id === object.labelId){

						if(getState().directoryGroupReducer.isCollapsed.includes(object.labelId) === false){
							dispatch(isCollapsed([...getState().directoryGroupReducer.isCollapsed.filter((collapsedItem) => collapsedItem !== object.labelId)]));
						}

						childOuItem.childOu.forEach(childOuItemLv2 => {
							dispatch(isHidden([...getState().directoryGroupReducer.isHidden.filter((collapsedItem) => collapsedItem !== childOuItemLv2.id)]));
						});
					}
				})
			}

		});
	}
}

export function toggleOrgUnit (groupId, ouSharingPermission, ownerId) {
	return function (dispatch, getState) {
		axios.put(API_ROOT + '/api/v2/directory/orgUnit/toggle', {
			"groupId": groupId,
			"ouSharingPermission": ouSharingPermission,
			"ownerId": ownerId
		}, {withCredentials: true}).then(response => {
			dispatch(flash({type: 'success', message: response.data}));
			const selected = getState().contactsGroupItemReducer.getSelectedContactsGroup || {};
			if (String(selected.id) === String(groupId)) {
				dispatch(getSelectedContactsGroup({
					...selected,
					ouSharingPermission: ouSharingPermission
				}));
			}
			dispatch(findDirectoryGroups());
			dispatch(findCollaborators(groupId, getState().sharingDetailsReducer.collaboratorsPageSize));
		}).catch(e => {
			if(e.response){
				dispatch(flash({type: 'danger', message: e.response.data}))
			} else {
				dispatch(flash({type: 'danger', message: e.message}))
			}
		});
	}
}

export function waitingDirectoryGroupsLevel (int) {
	return {
		type: 'WAITING_DIRECTORY_GROUPS_LEVEL',
		payload: int
	}
}
